module.exports = __webpack_public_path__ + "static/media/arquitect_7.da87717e.jpeg";